/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Contact_LedeInputs */

const en_marketing_contact_lede = /** @type {(inputs: Marketing_Contact_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No forms, no queues. Questions about Onyx, licensing, or an engagement all land in the same place.`)
};

const es_marketing_contact_lede = /** @type {(inputs: Marketing_Contact_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin formularios ni colas. Las preguntas sobre Onyx, la licencia o una colaboración llegan todas al mismo sitio.`)
};

const fr_marketing_contact_lede = /** @type {(inputs: Marketing_Contact_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de formulaires, pas de files d'attente. Les questions sur Onyx, la licence ou une mission arrivent toutes au même endroit.`)
};

/**
* | output |
* | --- |
* | "No forms, no queues. Questions about Onyx, licensing, or an engagement all land in the same place." |
*
* @param {Marketing_Contact_LedeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_contact_lede = /** @type {((inputs?: Marketing_Contact_LedeInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Contact_LedeInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_contact_lede(inputs)
	if (locale === "es") return es_marketing_contact_lede(inputs)
	return fr_marketing_contact_lede(inputs)
});